module.exports = __webpack_public_path__ + "media/images/toggle-on-icon-green-ee9c1f2c4ec38932f2c6d9fd06ab8366.png";